// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"791a642f","61":"39a51ae7","184":"b9ee4e6b","240":"166fcbdf","289":"51533770","299":"7ede52b5","581":"b34971ef","666":"e3218f20","798":"4a2a7a9f","848":"db2f6c64","902":"c1f0d415"}[chunkId] + ".chunk.js";
};